export default {
  getTimeLeft: function(datetimeTo) {
    // console.log(datetimeTo);
    // 计算目标与现在时间差（毫秒）
    let time1 = new Date(datetimeTo).getTime();
    let time2 = new Date().getTime();
    // console.log(time1,time2);
    let mss = time1 - time2;

    // 将时间差（毫秒）格式为：天时分秒
    let days = parseInt(mss / (1000 * 60 * 60 * 24));
    let hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = parseInt((mss % (1000 * 60)) / 1000);

    return days + "天" + hours + "时" + minutes + "分" + seconds + "秒";
  },
  flexBoz: function(oBox) {
    // oBox.style.cursor = "se-resize";
    let a = 0;
    let b = 0;
    let X, Y, oBoxW, oBoxH, oBoxL;
    // 鼠标按下
    oBox.onmousedown = function(ev) {
      var oEvent = ev || event;
      X = oEvent.clientX;
      Y = oEvent.clientY;
      oBoxW = oBox.offsetWidth;
      oBoxH = oBox.offsetHeight;
      oBoxL = oBox.offsetLeft;
      if (X > oBox.offsetLeft + oBox.offsetWidth - 5) {
        a = "right";
      } else if (Y > oBox.offsetTop + oBoxH - 10) {
        a = "bottom";
      } else if (X < oBox.offsetLeft + 5) {
        a = "left";
      }
      // 鼠标移动
      document.onmousemove = function(ev) {
        // oBox.style.cursor = "w-resize";
        var oEvent = ev || event;
        var XX = oEvent.clientX;
        var YY = oEvent.clientY;
        if (a == "right") {
          oBox.style.width = oBoxW + (XX - X) + "px";
        } else if (a == "bottom") {
          oBox.style.height = oBoxH + (YY - Y) + "px";
        } else if (a == "left") {
          oBox.style.width = oBoxW + (X - XX) + "px";
          oBox.style.left = XX - X + oBoxL - 5 + "px";
        }
      };
      // 鼠标移开
      document.onmouseup = function() {
        document.onmousedown = null;
        document.onmousemove = null;
      };
    };
  },
  // 鼠标拖放
  dragDrop(tag) {
    // 鼠标按下
    tag.onmousedown = function(ev) {
      // 鼠标移动
      document.onmousemove = function(ev) {
        tag.style.left = ev.clientX - 50 + "px";
        tag.style.top = ev.clientY - 50 + "px";
      };
      // 鼠标移开
      document.onmouseup = function() {
        document.onmousedown = null;
        document.onmousemove = null;
      };
    };
  },
  /**
   * 初始化拖拽
   **/
  dragablize(ctn) {
    var items = ctn.querySelectorAll(".flex-item"),
      lastX;
    Array.from(items).map(function(item) {
      item.onmousedown = function(event) {
        var target = event.target || event.srcElement,
          prevItem = target.previousElementSibling,
          suffItem = target.nextElementSibling;

        lastX = event.clientX;
        if (suffItem && event.offsetX > this.offsetWidth - 10) {
          item.mouseDown = true;
          item.oldX = event.x;
          item.oldWidth = item.offsetWidth;
        } else if (prevItem && event.offsetX < 10) {
          // 左边拖拽时，实际设置前置元素的宽度
          var evt = newMouseEvent(event, "mousedown");
          prevItem.dispatchEvent(evt);
        }
      };
      item.onmouseup = function(event) {
        var target = event.target || event.srcElement,
          prevItem = target.previousElementSibling;
        item.mouseDown = false;
        item.style.cursor = "";
        lastX = null;
        if (prevItem) {
          // 左边拖拽时触发前置元素mouseup，避免响应异常
          var evt = newMouseEvent(event, "mouseup");
          prevItem.dispatchEvent(evt);
        }
      };
    });
    ctn.onmousemove = function(event) {
      var target = event.target || event.srcElement;
      if (Array.from(items).includes(target)) {
        var prevItem = target.previousElementSibling,
          suffItem = target.nextElementSibling,
          direction = event.clientX - lastX;
        /**
         * 改变鼠标样式
         * 1：中间的元素左右边都可拖拽样式（左边拖拽时，实际设置前置元素宽度）
         * 2：没有前置元素的只能有右边拖拽样式
         * 3：没有后置元素的只能有左边拖拽样式
         **/
        if (
          (suffItem && event.offsetX > target.offsetWidth - 10) ||
          (prevItem && event.offsetX < 10)
        ) {
          target.style.cursor = "col-resize";
        } else {
          target.style.cursor = "";
        }
        //调整宽度
        var item = getClickedTarget(items);
        if (item && item.mouseDown && direction) {
          setWidth(item, direction);
          lastX = event.clientX;
        }
      }
    };
    function setWidth(item, offset) {
      var style = getComputedStyle(item),
        width = style.width.replace("px", "") - 0;
      // maxWidth、minWidth 防止flex布局对宽度计算的影响
      item.style.width = width + offset + "px";
      item.style.maxWidth = width + offset + "px";
      item.style.minWidth = width + offset + "px";
    }
  },

  getClickedTarget(items) {
    var t;
    Array.from(items).map(function(item) {
      if (item.mouseDown == true) t = item;
    });
    return t;
  },
  /**
   * 创建鼠标事件
   **/
  newMouseEvent(event, eventType) {
    var clientX = event.clientX,
      clientY = event.clientY,
      screenX = event.screenX,
      screenY = event.screenY;
    var simEvent = new MouseEvent(eventType, {
      clientX: clientX,
      clientY: clientY,
      screenX: screenX,
      screenY: screenY
    });
    return simEvent;
  },

  format(val) {
    return Number(val) < 10 ? "0" + val : "" + val;
  },
  // 时间戳转换
  formatDate(date) {
    var year = date.getFullYear();
    var month = this.format(date.getMonth() + 1);
    var da = this.format(date.getDate());
    // var h = this.format(date.getHours())
    // var m = this.format(date.getMinutes())
    // var s = this.format(date.getSeconds())
    // return year + '-' + month + '-' + da + ' ' + h + ':' + m + ':' + s
    return year + "-" + month + "-" + da;
  },
  // 时间戳转换
  formatDateyyyymmddhms(date) {
    var year = date.getFullYear();
    var month = this.format(date.getMonth() + 1);
    var da = this.format(date.getDate());
    var h = this.format(date.getHours());
    var m = this.format(date.getMinutes());
    var s = this.format(date.getSeconds());
    return year + "-" + month + "-" + da + " " + h + ":" + m + ":" + s;
  },
  // 时间戳转换
  formatDateyyyymmddhmsDayCalculate(date, dayVal) {
    var year = date.getFullYear();
    var month = this.format(date.getMonth() + 1);
    var da = this.format(date.getDate() + dayVal);
    var h = this.format(date.getHours());
    var m = this.format(date.getMinutes());
    var s = this.format(date.getSeconds());
    return year + "-" + month + "-" + da + " " + h + ":" + m + ":" + s;
  },

  //页面缩放
  pageResize: function() {
    const settings = JSON.parse(localStorage.getItem("settings")) || {};
    const Cfg = {
      designW: settings.designW || 1920, //设计图宽度
      designH: settings.designH || 1080, //设计图高度
      zoomMode: settings.zoomMode || (innerWidth < 768 ? "cover" : "contain"),
      notebookOptim: [undefined, true].includes(settings.notebookOptim)
    };
    let scale = 1;
    let notebookOptim = true;
    let [pageH, pageW] = [window.innerHeight, window.innerWidth];
    let isWider = pageW / pageH > Cfg.designW / Cfg.designH;
    let [scaleW, scaleH] = [pageW / Cfg.designW, pageH / Cfg.designH];
    let $container = document.getElementsByClassName("content")[0];

    switch (Cfg.zoomMode) {
      case "contain":
        scale = isWider ? scaleH : scaleW;
        break;
      case "cover":
        scale = isWider ? scaleW : scaleH;
        break;
      case "stretch":
        scale = isWider ? scaleH : scaleW;
        $container.cssText = "width: '100%';height: '100%'";
        break;
    }
    document
      .getElementsByTagName("html")[0]
      .setAttribute("style", "font-size:" + scale * 16 + "px;" + "opacity:1");
    notebookOptim = !(Cfg.notebookOptim === false || scale > 0.75);
  },
  windowResize: function(that, chartArr) {
    //浏览器发生变化时 添加后pc端无法适配
    let _this = this;
    _this.pageResize();
    alert(1);
  }
};



//////////////////
// WEBPACK FOOTER
// ./common_function/common.js
// module id = null
// module chunks = 